export const PLATFORM = Object.freeze({
    DESKTOP: 1,
    MOBILE: 2,
    APP: 3
  })
  